<div class="main-header d-flex w-100  align-items-center" [ngClass]="{'app-telemedicine-minimized-container': checktelemedicine()}">
  <!-- <ng-template [ngIf]="mobileSidebarToggler != false">
  <button class="navbar-toggler {{sidebarTogglerMobileClass}}" type="button" appSidebarToggler>
    <span class="navbar-toggler-icon"></span>
  </button>
</ng-template> -->


<!-- Mobile Toggler -->
@if (mobileSidebarToggler != false && !hideMenuIcon && !baseService.backNavigation) {
  <button class="navbar-toggler {{sidebarTogglerMobileClass}}" type="button" appSidebarToggler
    (click)="appService.sideBarOpen()">
    <i class="fa fa-bars kx-menu-toggle-icon" aria-hidden="true"></i>
  </button>
}
@if (sidebarToggler != false && !hideMenuIcon) {
  <button class="navbar-toggler {{sidebarTogglerClass}}" type="button" [appSidebarToggler]="sidebarToggler">
    <i class="fa fa-bars kx-menu-toggle-icon" aria-hidden="true"></i>
  </button>
}
@if (sidebarToggler != false && hideMenuIcon) {
  <button class="navbar-toggler" type="button" (click)="navigateBackUrl()">
    <i class="fa fa-times-circle kx-menu-toggle-icon" aria-hidden="true"></i>
  </button>
}
<!--for header back button-->
@if (baseService.backNavigation && !hideMenuIcon) {
  <button class="header-back" type="button" (click)="navigateBackUrl()">
    <i class="fa fa-arrow-left" aria-hidden="true"></i>
  </button>
}
<a class="navbar-brand org-logo-container" [routerLink]="navbarBrandRouterLink">
  @if (navbarBrandImg) {
    @if (navbarBrand) {
      <img [appHtmlAttr]="navbarBrand" [ngClass]="'navbar-brand'">
    }
    @if (navbarBrandFull && navbarBrandFull.src != undefined && navbarBrandFull.src != '' && headerJson!=undefined && headerJson.HeaderLogo!=undefined) {
      <img
        [attr.src]="headerJson.HeaderLogo" [attr.alt]="navbarBrandFull.alt" class="org-logo">
    }
    @if (!(navbarBrandFull && navbarBrandFull.src != undefined && navbarBrandFull.src != '')) {
      <img
        src="/assets/images/KareXpert_logo-n.png" class="org-logo">
      }
      <!-- <img *ngIf="navbarBrandMinimized" [appHtmlAttr]="navbarBrandMinimized" [ngClass]="'navbar-brand-minimized'"> -->
    }
    <!-- <ng-template [ngIf]="!navbarBrandImg">
    <div class="navbar-brand-full" [innerHTML]="navbarBrandText.text"></div>
    <div class="navbar-brand-minimized" [innerHTML]="navbarBrandText.icon"></div>
  </ng-template> -->
</a>
<!-- logo icon for mobile screen-->
<!-- <div class="_wf-pp-iconforapplicationmobile" [routerLink]="navbarBrandRouterLink">
<img *ngIf="headerJson!=undefined && headerJson.HeaderLogoMobile!=undefined" [attr.src]="headerJson.HeaderLogoMobile">
</div> -->

<!--for header title-->
@if (utilService.isMobile() && (utilService.getWidth() < utilService.getHeight()) && baseService._currentTitle != 'KareXpert' && hasHeaderValidation()) {
  <div class="header-page-title">{{baseService._currentTitle}}</div>
}
<!--
<div class="wf-pp-facilitynameformobile">
  EMR
</div>-->
<ng-content></ng-content>
</div>

<!-- <div class="container-fluid secondary-header d-flex w-100 align-items-center">

</div> -->